import React, { FunctionComponent } from 'react';
import { useDecision } from '@optimizely/react-sdk';
import { Experiments } from '../../constants/experiments';

import { DonateButton } from '../DonateButton/DonateButton';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => {
  const [{ variationKey: ShareButtonBorderExperiment }] = useDecision(
    Experiments.ShareButtonBorderFeature.ShareButtonBorderExperiment
      .experimentKey,
  );

  const isEnrolledInShareButtonBorderExperiment =
    ShareButtonBorderExperiment ===
    Experiments.ShareButtonBorderFeature.ShareButtonBorderExperiment.variations
      .BorderedShareButton;

  return (
    <>
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
        experiments={[Experiments.donate_now_track_click]}
        successType="StaticDonateButtonClick"
      />
      <Share
        buttonClassName={
          isEnrolledInShareButtonBorderExperiment ? 'jg-btn--ghost' : undefined
        }
      />
    </>
  );
};

export default FundraisingCTA;
